import axios, { AxiosResponse } from 'axios';
import { ClientContext } from '../../clientConfig';
import { getClientContext, toQueryString } from '../util/clientContextUtils';

type CallbackType<T> = (response: AxiosResponse, clientContext: ClientContext) => T;

export function fetchClientConfiguration<T>(callback: CallbackType<T>, onError: (err: any) => void): Promise<T | void> {
    const clientContext = getClientContext();
    const queryString = toQueryString(clientContext);

    const path = '/api/config';
    const url = queryString ? `${path}?${queryString}` : path;

    return axios
        .get(url, {
            headers: {
                'Cache-Control': 'private, max-age=300',
            },
        })
        .then((response) => callback(response, clientContext))
        .catch(onError);
}
